<template>
     <dialog-layout ref="remedialDailog" id="remedialDailog" @click="dialogActions">
        <h3 slot="headercontent" v-if="remedial">Remedial</h3>
        <remedial-new-layout ref="remediallayout" :remedial="remedial" :templateconfig="templateconfig" @click="c"/>                 
     

        <!-- <large-button v-if="remedial && remedial.id" @click="saveRemedial">Save Remedial</large-button> -->
        <large-button v-if="remedial && !remedial.id  
                && remedial.createdfrombusiness 
                && remedial.linkedbusiness && remedial.issue" 
          @click="addRemedial">{{remedial.type==='lodge'?'Lodge':'Add'}} Remedial</large-button>

    </dialog-layout>  

</template>

<script>
import {mapActions,mapGetters} from "vuex";
export default {      
  data: function() {
    return {
        remedial:null,
        meta:null,
        business:null,
        template:"<div>{{remedial}}</div>"
    };
  },
  computed: {
      ...mapGetters(["templateconfig"])
    },
  methods: {    
    c(event){
      console.dir(event)
    },
    ...mapActions(['fullremedial','remedialCommands','location']),    
    add(args){
        this.meta = (args && args.meta)||null        
        this.remedial = {createAs:'linkedremedial'}        
        this.$refs.remedialDailog.show()      
    },
    lodge(args){
        this.meta = (args && args.meta)||null        
        this.remedial = {createAs:'lodgedremedial'}              
        this.$refs.remedialDailog.show()     
    },
    addRemedial(){   
      let createdfrombusiness  = this.remedial.createdfrombusiness   
      delete this.remedial.createdfrombusiness      
      
      this.remedialCommands({command:'addNewRemedial',remedial:this.remedial,business:createdfrombusiness})
      this.$refs.remedialDailog.cancelDialog(this)
    },   
    cancelDialog(){      
        this.$refs.remedialDailog.cancelDialog(this)                   
    },
    dialogActions(e) {         
      if(e.action==='canceldialog')
      {
        this.remedial = null
        this.meta = null       
      }        
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/shared/RemedialDialog.vue